"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getEventsFromInput = getEventsFromInput;
exports.pathStrToObj = pathStrToObj;

var _remove2 = _interopRequireDefault(require("lodash/remove"));

var _isObject2 = _interopRequireDefault(require("lodash/isObject"));

var _flatMap2 = _interopRequireDefault(require("lodash/flatMap"));

var _populate = require("./populate");

var _query = require("./query");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function pathStrToObj(path) {
  let pathObj = {
    path,
    type: 'value',
    isQuery: false
  };
  const queryId = (0, _query.getQueryIdFromPath)(path);

  if (queryId) {
    const pathArray = path.split('#');
    pathObj = Object.assign({}, pathObj, {
      queryId,
      isQuery: true,
      path: pathArray[0],
      queryParams: pathArray[1].split('&')
    });

    if ((0, _populate.getPopulates)(pathArray[1].split('&'))) {
      pathObj.populates = (0, _populate.getPopulates)(pathArray[1].split('&'));
      pathObj.queryParams = (0, _remove2.default)(pathArray[1].split('&'), p => p.indexOf('populate') === -1);
    }
  }

  return pathObj;
}

function getEventsFromInput(paths) {
  return (0, _flatMap2.default)(paths, path => {
    if (typeof path === 'string' || path instanceof String) {
      return [pathStrToObj(path)];
    }

    if (Array.isArray(path)) {
      return [{
        type: 'first_child',
        path: path[0]
      }, {
        type: 'child_added',
        path: path[0]
      }, {
        type: 'child_removed',
        path: path[0]
      }, {
        type: 'child_moved',
        path: path[0]
      }, {
        type: 'child_changed',
        path: path[0]
      }];
    }

    if ((0, _isObject2.default)(path)) {
      if (!path.path) {
        throw new Error('Path is a required parameter within definition object');
      }

      let strPath = path.path;

      if (path.storeAs) {
        strPath += `@${path.storeAs}`;
      }

      if (path.queryParams) {
        strPath += `#${path.queryParams.join('&')}`;
      }

      path = Object.assign({}, pathStrToObj(strPath), path);
      return [path];
    }

    throw new Error(`Invalid Path Definition: ${path}. Only strings, objects, and arrays accepted.`);
  });
}

var _default = {
  getEventsFromInput
};
exports.default = _default;